/**
 * Understory's own standalone site identity.
 *
 * The magazine is reachable both in-app at `/magazine` and as a standalone site
 * on its own domain. A Vercel host-rewrite serves the SPA shell at `/` for that
 * domain; `toolRouteForHost` (lib/hostTool) then routes it to `/magazine` on
 * boot, and `isMagazineEnabled` (flag) treats the domain as always-on. Keep the
 * host here as the single source of truth — it's pinned to vercel.json by
 * services/blades/__tests__/vercelRewrites.test.ts.
 */
export const MAGAZINE_HOST = 'understory.beetlesense.ai'

/** True when the hostname is the magazine's own domain (www- and case-insensitive). */
export function isMagazineHost(hostname: string | undefined | null): boolean {
  if (!hostname) return false
  return hostname.replace(/^www\./i, '').toLowerCase() === MAGAZINE_HOST
}
